//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import angular from 'angular';

import IItemMetadata from '@models/IItemMetadata';
import { SELECTED_ITEM } from '@uia/selected-item/selected-item-constants';
import { createAction } from '@utils/actions';
import PartialCuid from '@models/PartialCuid';

const fetchItemMetadata = () => {
  return createAction({
    type: SELECTED_ITEM.FETCH_ITEM_METADATA,
  });
};

const receiveItemMetadata = (metadata: IItemMetadata) => {
  return createAction({
    type: SELECTED_ITEM.RECEIVE_ITEM_METADATA,
    metadata,
  });
};

const reloadItemMetadata = (cuid: PartialCuid) => {
  return createAction({
    type: SELECTED_ITEM.RELOAD_ITEM_METADATA,
    cuid,
  });
};

const reloadedItemMetadata = () => {
  return createAction({
    type: SELECTED_ITEM.RELOADED_ITEM_METADATA,
    cuid: undefined,
  });
};

export type SelectedItemAction = ReturnType<
  | typeof fetchItemMetadata
  | typeof receiveItemMetadata
  | typeof reloadItemMetadata
  | typeof reloadedItemMetadata
>;

export const selectedItemActions = {
  receiveItemMetadata,
  reloadItemMetadata,
  reloadedItemMetadata,
};

angular.module('curalate').service('SelectedItemActions', function () {
  this.receiveItemMetadata = receiveItemMetadata;
});
